/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { UserDetails } from 'app/user-auth/models';
import { defaultLoadableState, LoadableState } from '@opengamma/ui';

/** User Auth state definition. */
export interface UserAuthState {
  userDetails: LoadableState<UserDetails>;
}

/** The initial user auth state. */
export const INITIAL_STATE: UserAuthState = {
  userDetails: defaultLoadableState()
};
